import { Injectable } from '@angular/core';

import { Observable, map, share } from 'rxjs';

import { QuickDepositService } from '../../../quick-deposit/services/quick-deposit.service';
import { PlaceButtonExternalState } from '../../place-button.models';

@Injectable()
/**
 * This service is used to bundle state that is not coming from NGRX for various reasons and make it available to the place bet button services.
 */
export class PlaceButtonExternalStateService {
    private state$: Observable<PlaceButtonExternalState>;

    constructor(quickDeposit: QuickDepositService) {
        // Currently only the quick desposit service is used here because it does not have a dedicated state in the store yet.
        this.state$ = quickDeposit.isQuickDepositLoaderEnabled$.pipe(map(this.mapState), share());
    }

    private mapState(isQuickDepositLoaderEnabled: boolean): PlaceButtonExternalState {
        return {
            isQuickDepositProcessing: isQuickDepositLoaderEnabled,
        };
    }

    get externalState$(): Observable<PlaceButtonExternalState> {
        return this.state$;
    }
}
